import { ArticleJsonLdProps, NextSeoProps } from 'next-seo';

import pageRoutes from '../../router/pageRoutes';
import { StrapiApiArticleAttributes, StrapiApiTag } from '../integrations/strapi/types';

export const getBlogPostJsonSeoConfig = (attributes: StrapiApiArticleAttributes): ArticleJsonLdProps => {
  const { title, seo_description: description, imageUrl, publishedAt, page_url } = attributes;
  const url = `${pageRoutes.Blog}/${page_url}`;
  const datePublished = String(publishedAt);
  const images = [imageUrl];
  return { useAppDir: false, isAccessibleForFree: true, url, title, description, images, datePublished, authorName: 'N/A' };
};

export const getBlogPostPageSeoConfig = (attributes: StrapiApiArticleAttributes, tags?: StrapiApiTag[]): NextSeoProps => {
  const { title, seo_description: description, imageUrl, imageDescription, publishedAt, page_url } = attributes;
  const url = `${pageRoutes.Blog}/${page_url}`;
  const articleSeo = {
    publishedTime: String(publishedAt),
    authors: [],
    tags: (tags || []).map((tag) => tag.attributes.name),
  };
  const images = [{ url: imageUrl, alt: imageDescription, type: 'image/jpeg' }];
  return { title, description, openGraph: { url, title, type: 'article', description, images, article: articleSeo } };
};
